import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navLinks = [{
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Shop',
    href: '#shop'
  }, {
    name: 'Blog',
    href: '#blog'
  }, {
    name: 'Specials',
    href: '#specials'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A] border-b border-white/10" data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex justify-between items-center h-[60px] md:h-20" data-id="element-103">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-104">
            <a href="#" data-id="element-105">
              <img src="https://cdn.magicpatterns.com/uploads/kHPY5hn7jL6QdVkj1vf8yR/raise_the_bar_white.png" alt="Raise The Bar Med Spa" className="w-[120px] object-contain" data-id="element-106" />
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-107">
            <div className="flex space-x-6" data-id="element-108">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-white hover:text-[#C8A84E] transition-colors font-sans text-sm tracking-wide uppercase" style={{
              fontFamily: "'Montserrat', sans-serif"
            }} data-id="element-109">
                  {link.name}
                </a>)}
            </div>
            <a href="#book" className="bg-[#C8A84E] hover:bg-[#b39542] text-black px-6 py-2.5 rounded-full font-semibold transition-all duration-300 transform hover:scale-105" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-110">
              Book Now
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="lg:hidden flex items-center" data-id="element-111">
            <button onClick={() => setIsOpen(!isOpen)} className="text-white hover:text-[#C8A84E] focus:outline-none p-2" aria-label={isOpen ? 'Close menu' : 'Open menu'} data-id="element-112">
              {isOpen ? <X className="h-6 w-6" data-id="element-113" /> : <Menu className="h-6 w-6" data-id="element-114" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Drawer */}
      {isOpen && <div className="lg:hidden bg-[#0A0A0A] border-t border-white/10 absolute w-full left-0 shadow-2xl" data-id="element-115">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-116">
            {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-4 text-white hover:text-[#C8A84E] border-b border-white/5 font-sans text-sm tracking-widest uppercase" style={{
          fontFamily: "'Montserrat', sans-serif"
        }} onClick={() => setIsOpen(false)} data-id="element-117">
                {link.name}
              </a>)}
            <div className="pt-6 pb-2 px-3" data-id="element-118">
              <a href="#book" className="block w-full text-center bg-[#C8A84E] text-black px-6 py-3 rounded-full font-semibold min-h-[52px] flex items-center justify-center" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} onClick={() => setIsOpen(false)} data-id="element-119">
                Book Now
              </a>
            </div>
          </div>
        </div>}
    </nav>;
}